define('views/shared/form/input/text_group_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/text_group_component.html',
    'views/shared/form/input/text_component',
    'views/shared/form/input/text_mute_component',
    'views/shared/form/input/city_component',
    'views/shared/form/input/state_component',
    'views/shared/form/input/zipcode_component'
], function(Backbone, BaseView, Template, TextComponent, TextMuteComponent, CityComponent, StateComponent, ZipcodeComponent){
    'use strict';

    return BaseView.extend({
        className: 'form-group',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {},

        initialize: function(options){
            options = options || {};

            this.fields = options.fields;

            this.active_fields = [];
            this.is_valid = false;

            this.is_group = true;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            this.render();

            this.addFields();
            
        },

        addFields: function(){
            var that = this;

            if(_.isArray(this.fields)){

                this.fields.forEach(function(field, index){

                    // console.log('group field:', field);
                    

                    switch(field.component_type){
                        case enums.formComponentTypes.first_name:
                            var input_field = new TextComponent({ field: field, context: that });
                            break;
                        case enums.formComponentTypes.last_name:
                            var input_field = new TextComponent({ field: field, context: that });
                            break;
                        case enums.formComponentTypes.city:
                            var input_field = new CityComponent({ field: field, context: that });
                            break;
                        case enums.formComponentTypes.state:

                            if (field.editable) {
                                var input_field = new StateComponent({ field: field, context: that });
                            } else {
                                var input_field = new StateComponent({ field: field, muted: true,  context: that });
                            }
                            break;
                        case enums.formComponentTypes.zipcode:
                            if (field.editable) {
                                var input_field = new ZipcodeComponent({ field: field, context: that });
                            } else {
                                var input_field = new TextMuteComponent({ field: field, context: that });
                            }
                            break;
                        default:
                            var input_field = null;
                            break;
                    };

                    if(input_field){
                        that.active_fields.push(input_field);
                        that.$el.append(input_field.el);
                    }

                });

            }

        },

        showError: function(outline_error){
            // console.log('text_group_component showError',this);

            if(_.isArray(this.active_fields)){

                var errors = [];

                this.active_fields.forEach(function(field, index){

                    if(!field.is_valid){

                        if(_.isFunction(field.showError)){
                            errors.push(field);

                            if(outline_error){
                                field.showDataMatchingError();
                            } else {
                                field.showError();
                            }
                            
                        } else if(field.error && field.is_valid){

                            if(_.isFunction(field.removeError)){
                                field.removeError();
                            }

                        }

                    }

                });

                if(errors.length == 0){
                    this.is_valid = true;
                } else {
                    this.is_valid = false;
                }

            }

        },

        showDataMatchingError: function(){
            this.showError(true);
        },

        updateStatus: function(){

            if(_.isArray(this.active_fields)){

                var errors = [];

                this.active_fields.forEach(function(field, index){

                    if(!field.is_valid){

                        errors.push(field);

                    }

                });

                if(errors.length == 0){
                    this.is_valid = true;
                } else {
                    this.is_valid = false;
                }

            }

        },

        updateValue: function(val, sub_component_type){

            if(_.isArray(this.active_fields)){

                this.active_fields.forEach(function(field, index){

                    console.log('updateValue', field, sub_component_type);

                    if(field.component_type == sub_component_type){

                        field.updateValue(val);

                    }

                });

            }

        },

        close: function(){}
    });
});

